module.exports = __webpack_public_path__ + "img/581.64f9d30e.jpg";